import { VideoPlayer } from '@components/common'
import conf from '@configuration'
import {Product, ProductItem, ProductType} from '../../../types/rest'
import React, {useCallback, useState} from 'react'
import useMediaQuery from '../../../hooks/useMediaQuery'
import { small } from '../../../constants'
import styled from 'styled-components'
import {logger} from "@helpers"
import useRest from "../../../hooks/useRest"


type Props = {
  product: Product
  selectedItem: { item: ProductItem, keep: boolean }
  setPlayInline: ()=> void
  reloadContent?: ()=> void

}
// Componente per visualizzare il trailer del prodotto, si vede premendo sul tasto |> trailer
const InlineContentPlayer: React.FC<Props> = ({ product, selectedItem, setPlayInline,reloadContent }) => {
  const isMobile = useMediaQuery(`(max-width: ${small})`)
  const stopPlayingTrailer = useCallback(() => setPlayInline(), [setPlayInline])
  const { put, remove} = useRest<ProductItem>('keep-watching')
  const [isMenuOpen, setMenuOpen] = useState<boolean>(false)
  const [isLoading, setIsLoading]= useState<boolean>(true)

  const onPlayerReady = useCallback((vp: any) => {
    if(!vp) return
    vp.addEventListener('error', logError)
    if (vp.currentTime === 0) {
      vp.currentTime = selectedItem?.item.time || 0
    }
    vp.addEventListener('ended', stopPlayingTrailer)
  },[selectedItem])


  const onPlayerDispose = useCallback((vp: any) => {
    if (!vp) return
    if (Math.round(vp.currentTime) === 0) return remove(selectedItem.item.id).catch((err) => logger.error(err))
    if (Math.round(vp.currentTime) >= vp.duration * 0.95) {
      put( selectedItem.item.id, {time: 0}).catch((err) => logger.error(err))
    } else {
      put(selectedItem.item.id, {time: Math.round(vp.currentTime)}).catch((err) => logger.error(err))
    }
  }, [selectedItem])

  if (selectedItem?.item.video?.url ) {
    return (
      <VideoContainer isMobile={isMobile}>
        <VideoPlayer
          setIsLoading={(state: boolean)=> setIsLoading(state)}
          reloadContent={reloadContent}
          isInline={true}
          entityName={'products'}
          entityId={selectedItem?.item.video?.id}
          productId={selectedItem.item.product}
          product={(product.type as ProductType).label === 'course' ? product : undefined}
          item={(product.type as ProductType).label === 'course' ? selectedItem?.item : undefined}
          onPlayerReady={onPlayerReady}
          openMenu={()=>setMenuOpen(prev => !prev)}
          isMenuOpen={isMenuOpen}
          onPlayerDispose={onPlayerDispose}
          setPlayInline={()=>setPlayInline()}
          src={`${conf.wowzaUrl}${selectedItem.item.video?.url}${conf.wowzaOption}`}
          options={{
            controls: true,
            muted: false,
            fill: true,
            autoplay: false,
            inactivityTimeout: 4000,
            sources: [
                {
                  src: `${conf.wowzaUrl}${selectedItem.item.video?.url}${conf.wowzaOption}`
                }
            ]
          }}
          style={{
            margin: '0',
            height: 'auto',
            aspectRatio: '16 / 9',
            width: '100%'
          }}
          poster={product.thumbnail}
        />
      </VideoContainer>
    )
  } else {
    return <></>
  }
}

export default InlineContentPlayer

const logError = (evt: any) => {
  logger.error(evt)
}

//region Style

const flatProduct = (product: Product | ProductItem): ProductItem[] => {
  // restituisce un array di contenuti posizionati in ordine di riproduzione
  const array: ProductItem[] = []
  const childListName = Object.keys(product).includes('productItems') ? 'productItems' : 'children';
  (product as any)[childListName].sort(compareFn).forEach((item: ProductItem) => {
    if (item?.video || item?.live)array.push(item)
    else if (item.children.length > 0)
      array.push(...flatProduct(item))
  })
  return array
}

const compareFn = (a: ProductItem, b: ProductItem) => {
  if (a.sequence < b.sequence) return -1
  if (a.sequence > b.sequence) return 1
  else return 0
}

const VideoContainer = styled.div<{ isMobile: boolean }>`
  height: auto;
  max-width: var(--max-content-width);
  width: 100%;
  position: relative;
  margin: 0 auto;
  display: flex;
  justify-content: center;
  align-items: center;
  overflow: hidden;
  & > img {
    flex-shrink: 0;
    min-width: 100%;
    min-height: 100%;
  }
`

//endregion
